import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4">АЛІБІ.НЕТ.ЮА</h3>
              <p className="text-gray-400 mb-4">
                ТОВ "ІНФОРМАЦІЙНЕ АГЕНТСТВО "АЛІБІ.НЕТ.ЮА"<br />
                Професійні інформаційні послуги в Україні з 2019 року
              </p>
              <p className="text-sm text-gray-500">
                Код ЄДРПОУ: 43184468<br />
                КВЕД: 63.91 Діяльність інформаційних агентств
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Швидкі посилання</h4>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <button 
                    onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                    className="hover:text-white transition-colors"
                  >
                    Про нас
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                    className="hover:text-white transition-colors"
                  >
                    Послуги
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                    className="hover:text-white transition-colors"
                  >
                    Контакти
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Контакти</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>
                  <a href="tel:+380504623421" className="hover:text-white transition-colors">
                    +38 (050) 462-34-21
                  </a>
                </li>
                <li>
                  <a href="tel:+380967859576" className="hover:text-white transition-colors">
                    +38 (096) 785-95-76
                  </a>
                </li>
                <li className="pt-2">
                  м. Київ, 04060<br />
                  вул. Бориса Житкова, 7/12
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-500 text-sm mb-4 md:mb-0">
                © {currentYear} АЛІБІ.НЕТ.ЮА. Всі права захищені.
              </p>
              <div className="flex space-x-6 text-sm text-gray-500">
                <button className="hover:text-white transition-colors">
                  Політика конфіденційності
                </button>
                <button className="hover:text-white transition-colors">
                  Умови використання
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
